import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import { searchContestOffersForMonth } from "@/components_v3/affiliate/contest/shared/api/contest-cashback.api";
import ContestOfferSpecialPeriodRow from "@/components_v3/affiliate/contest/features/offer-edit/ui/contest-offer-special-period/ContestOfferSpecialPeriodRow.vue";
import {
    CONTEST_CASHBACK_MAX_DIGITS,
    CONTEST_CASHBACK_MAX_INT,
} from "@/components_v3/affiliate/contest/shared/config/contest-limits";
import { parseContestPlanFieldValue } from "@/components_v3/affiliate/contest/shared/lib/parse-offer-money.lib";
import BaseAutocomplete from "@/components-UI/BaseAutocomplete.vue";
import BaseChip from "@/components-UI/BaseChip.vue";
import BaseButton from "@/components-UI/BaseButton.vue";
import BaseInputNumber from "@/components-UI/BaseInputNumber.vue";
import SvgEdit from "@/assets/icons/pencil.svg";
import SvgReload from "@/assets/icons/reload.svg";
import SvgCheck from "@/assets/icons/check.svg";
import SvgTrash from "@/assets/icons/trash-dark.svg";

import { IContestSpecialPeriod } from "@/components_v3/affiliate/contest/entities/cashback-offer/model/types";

interface Props {
    offerId?: number | null;
    offerName?: string | null;
    plan?: number | null;
    month: string;
    specialPeriodEnabled?: boolean;
    specialPeriod?: IContestSpecialPeriod | null;
    isEditing?: boolean;
    isNew?: boolean;
    isSubmitting?: boolean;
    canSave?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ContestOfferCardHeader',
  props: {
    offerId: { default: null },
    offerName: { default: null },
    plan: { default: null },
    month: null,
    specialPeriodEnabled: { type: Boolean, default: false },
    specialPeriod: { default: null },
    isEditing: { type: Boolean, default: false },
    isNew: { type: Boolean, default: false },
    isSubmitting: { type: Boolean, default: false },
    canSave: { type: Boolean, default: false }
  },
  emits: ["edit", "delete", "cancel", "save", "update:offer-id", "update:plan", "update:special-period-enabled", "update:special-period"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'edit'): void;
    (e: 'delete'): void;
    (e: 'cancel'): void;
    (e: 'save'): void;
    (e: 'update:offer-id', offerId: number | null): void;
    (e: 'update:plan', plan: number | null): void;
    (e: 'update:special-period-enabled', enabled: boolean): void;
    (e: 'update:special-period', period: IContestSpecialPeriod | null): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { offerId: number | null, offerName: string | null, plan: number | null, month: string, specialPeriodEnabled: boolean, specialPeriod: IContestSpecialPeriod | null, isEditing: boolean, isNew: boolean, isSubmitting: boolean, canSave: boolean }





/** Remount после пустого clear: BaseInputNumber на blur пишет display «0», не трогаем kit. */
const planInputKey = ref(0);

const autocompleteOfferField = computed(() => ({
    emptyText: 'Оффер не найден',
    apiMethod: searchContestOffersForMonth,
    itemValue: 'legacy_id',
    template: (item: { legacy_id: number; name: string }) => `${item.legacy_id} ${item.name}`,
    placeholder: 'Выберите оффер',
    externalParams: {
        month: props.month,
        fields: 'legacy_id,name',
        'status[]': 'active',
    },
}));

function formatPlan(planValue: number | null): string {
    if (planValue == null) {
        return '';
    }

    return planValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

function remountPlanInput(): void {
    planInputKey.value += 1;
}

function onPlanRawChange(raw: unknown): void {
    const next = parseContestPlanFieldValue(raw);
    emit('update:plan', next);

    // Пустая строка: kit уже подставил display «0» — пересоздаём инпут с value=null.
    if (raw === '' || raw == null) {
        remountPlanInput();
    }
}

function onPlanClear(): void {
    emit('update:plan', null);
}

return { __sfc: true,props, emit, planInputKey, autocompleteOfferField, formatPlan, remountPlanInput, onPlanRawChange, onPlanClear, ContestOfferSpecialPeriodRow, CONTEST_CASHBACK_MAX_DIGITS, CONTEST_CASHBACK_MAX_INT, BaseAutocomplete, BaseChip, BaseButton, BaseInputNumber, SvgEdit, SvgReload, SvgCheck, SvgTrash }
}

})